module.exports = __webpack_public_path__ + "static/img/IMG_0448.44434f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fotosGaleriaSicarf/IMG_0448.jpg
// module id = ulUY
// module chunks = 12